import React, { Suspense } from 'react';
import { Loader } from 'components';
import Layout from 'components/layout';
import { Switch, Route, Redirect } from "react-router-dom";


const Login = React.lazy(() => import('pages/login'));
const Dashboard = React.lazy(() => import('pages/dashboard'));
const Map = React.lazy(() => import('pages/map'));



const PrivateRoute = ({ children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        false ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location }
            }}
          />
        )
      } />
  );
}


const Routes = () => {
  /*   const user = useSelector(state => state.user); */
  return (
    <Switch>
      <Suspense fallback={<Loader loading={true} />}>

        <Layout>
        <Route exact path='/' component={Map} />
          
          <Route exact path='/login' component={Login} />
          <PrivateRoute path="/dashboard" exact>
            <Dashboard />
          </PrivateRoute>
        </Layout>
      </Suspense>
    </Switch>
  );
}

export default Routes;